export default __webpack_public_path__ + "static/media/ic_map_europe2.b7479ecb.svg";